import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageComponent } from './message/message.component';
import { ChatMessage } from '../../models/chatMessage';
import { FormsModule } from '@angular/forms';
import { UserDataService } from 'src/app/services/userData.service';
import { SignalRService } from 'src/app/services/communications/signalr.service';
import { ApiService } from 'src/app/services/communications/api.service';
import { ChatService } from 'src/app/services/chat.service';
import { Subscription } from 'rxjs';
import { chatFile } from 'src/app/models/chatFile';
import { CameraComponent } from '../cameraComponent/cameraComponent';
import { MatDialog } from '@angular/material/dialog';
import { RecordMediaService } from 'src/app/services/recordMedia.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FileHelperService } from '../../services/file-helper.service';
import { ChatMessageSystem, ChatMessageType, MediaType } from '../../constants/constants';
import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { SummaryModalComponent } from './summary/summary-modal.component';
import { Title } from '@angular/platform-browser';
import { LoggerService } from 'src/app/services/loggerService.service';
import { InterComunicacionService } from 'src/app/services/communications/intercommservice';
import { MatDividerModule } from '@angular/material/divider';
import { WhitelabelService } from '../../services/whitelabel.service';
import { SnackBarService } from '../../services/snackbar.service';
import { PickerComponent } from '@ctrl/ngx-emoji-mart';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import twemoji from 'twemoji';
import data from '@emoji-mart/data/sets/15/all.json';

@Component({
  selector: 'directCall-chat',
  imports: [CommonModule, MessageComponent, FormsModule, MatTooltipModule, TranslateModule, MatDividerModule, PickerComponent, MatMenuModule, MatIconModule],
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss', '../../styles/components/panel.scss']
})

export class ChatComponent implements OnInit, OnDestroy {

  @Input() stickyMode: boolean = false;
  @Output() close = new EventEmitter<string>();

  @ViewChild('messagesContainer') private messagesContainer!: ElementRef;
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('textarea') textarea!: ElementRef;
  @ViewChild('emojiPicker') emojiPicker!: ElementRef;

  newMessage: ChatMessage;
  initialMessage: ChatMessage;
  group: ChatMessage[][] = [];
  allowMembers = false;
  attachment: Blob | null = null;
  isDraggingFile = false;
  private dragCounter = 0;

  chatMessageReceivedSubscription: Subscription;
  deleteChatMessageSubscription: Subscription;
  onEditedImageEvent: Subscription;
  recordingFailSubscription: Subscription;
  recordedBlobSubscription: Subscription;

  swipeUpSubscription: Subscription | undefined;

  isMicAvailable = false;
  isRecordingVoice = false;
  loadingProgress: number = 0;
  loadingChat: boolean = false;
  lastChatMessageId: number | null = null;
  showDividerNewMessages: boolean = false;
  lastScrollTop: number = 0
  userScrollAtBottom: boolean = true;
  showEmojiPicker: boolean = false;
  emojiData: any;

  private originalTitle: string = '';
  private unreadMessages = 0;
  private readonly MAX_LENGTH_NOTIFICATIONS: number = 150;

  private readonly MAX_FORM_UPLOAD_SIZE = 250 * 1024 * 1024; // 250MB
  private readonly MAX_CHUNK_UPLOAD_SIZE = 3 * 1024 * 1024 * 1024; // 3GB

  private uploadFileSingleRequest = true;

  constructor(private userDataService: UserDataService, private signalService: SignalRService, private apiService: ApiService, private chatService: ChatService, private interComService: InterComunicacionService,
    public dialog: MatDialog, private recordMediaService: RecordMediaService, private translate: TranslateService, private fileHelperService: FileHelperService, private titleService: Title,
    private snackBarService: SnackBarService, private logger: LoggerService, private whitelabelService: WhitelabelService) {

    this.uploadFileSingleRequest = whitelabelService.getUploadFileSingleRequest();
    this.initialMessage = new ChatMessage(0, ChatMessageSystem.INITIAL_MESSAGE, undefined, undefined, whitelabelService.getChatInitialMessage(), undefined, null, null, null, ChatMessageType.System);
    this.newMessage = new ChatMessage(this.userDataService.Id!, '');

    this.chatMessageReceivedSubscription = this.signalService.onChatMessageReceived.subscribe(data => {
      console.log("onChatMessageReceived...", data);
      this.chatService.addMessage(data.chatData);
      this.group = this.chatService.addMessageToGroup(this.group, data.chatData);

      if (!this.showDividerNewMessages && data.chatData.chatFile == null) this.scrollDown("onChatMessageReceived");
      
      if (document.visibilityState === 'hidden' || !this.userScrollAtBottom) {
        this.unreadMessages++;
        this.updateTitle();

        var lastMessage = data.chatData; 
        var message = lastMessage?.message!;
        if (message == "" && lastMessage?.chatFile != null && lastMessage.chatFile?.fileId > 0) message = lastMessage.chatFile.fileName;

        this.showNotification(lastMessage?.userName!, message);
      }
    });

    this.deleteChatMessageSubscription = this.signalService.onDeleteChatMessage.subscribe(data => {
      console.log("onDeleteChatMessage...");
      this.deleteChatMessage(data);
      if (document.visibilityState === 'hidden') {
        this.unreadMessages--;
        this.updateTitle();
      }
    });

    this.recordingFailSubscription = this.recordMediaService.recordingFailed().subscribe(() => console.log("Record failed"));

    this.recordedBlobSubscription = this.recordMediaService.getRecordedBlob().subscribe(data => {
      const file: File = new File([data.blob], data.title, { type: 'audio/webm' });
      var mediaType = this.fileHelperService.getFileType(file.name);
      this.newMessage.chatFile = new chatFile(-1, file.name, mediaType, "", file);
    });

    this.onEditedImageEvent = this.chatService.onImageEdited.subscribe(file => {
      var mediaType = this.fileHelperService.getFileType(file.name);
      this.newMessage.chatFile = new chatFile(-1, file.name, mediaType, "", file);
    });

    this.swipeUpSubscription = this.interComService.datos$.subscribe(() => {
      console.log("Swipe up detected in chat component");
      this.loadPartialChat(true);
    });

    this.setupVisibilityListener();
  }

  ngOnInit(): void {
    this.originalTitle = this.titleService.getTitle();
    this.chatService.resetMessages();
    this.emojiData = data;
    this.loadPartialChat(true);

    this.recordMediaService.hasMicrophonePermission().then(hasPermission => {
      this.isMicAvailable = hasPermission;
      if (!hasPermission) {
        navigator.mediaDevices.getUserMedia({ audio: true })
          .then(stream => {
            stream.getTracks().forEach(track => track.stop()); // Libera el stream
            this.isMicAvailable = true;
          })
          .catch(err => {
            console.log("Permiso de micrófono denegado o error:", err);
          });
      }
    });
  }

  ngOnDestroy(): void {
    this.chatMessageReceivedSubscription.unsubscribe();
    this.deleteChatMessageSubscription.unsubscribe();
    this.recordingFailSubscription.unsubscribe();
    this.recordedBlobSubscription.unsubscribe();
    this.onEditedImageEvent.unsubscribe();
    this.swipeUpSubscription?.unsubscribe();
  }

  adjustTextareaHeight() {
    this.textarea.nativeElement.style.height = 'auto';

    const alturaDeseada = this.textarea.nativeElement.scrollHeight - 26;
    const alturaMaxima = 6 * 22; // Altura máxima de 6 líneas
    this.textarea.nativeElement.style.height = Math.min(alturaDeseada, alturaMaxima) + 'px';
  }

  resetTextareaHeight() {
    this.textarea.nativeElement.style.height = '34px'; //definido en el css
  }

  async addNewMessage(): Promise<void> {
    console.log("addnewmessage attachment : ", this.attachment);
    console.log("Message : ", this.newMessage.message, this.newMessage.userId, this.userDataService.ParticipantId);
    this.showDividerNewMessages = false;

    let translateChatOn = false;
    let translationLanguage = "";
    let color = "#ffffff";

    if (this.newMessage.userId && (this.newMessage.message.trim() || this.newMessage.chatFile?.file)) {
      let user = this.userDataService.assetInfo.participants.find(p => p.participantId == this.userDataService.ParticipantId);
      if (user == undefined) {
        console.log("UndefinedUser", user, this.userDataService);
        this.logger.error("Undefined user in chat component addNewMessage", { userDataService: this.userDataService });
      } else {
        translateChatOn = user.translateChatOn;
        translationLanguage = user.translationLanguage;
        color = user.color!;
      }

      var assistanceId = this.userDataService.assetInfo.parentId > 0 ? this.userDataService.assetInfo.assistances[0].id : null;

      this.newMessage = new ChatMessage(this.userDataService.Id!, this.newMessage.message, new Date(), this.userDataService.Name!, "", color, this.newMessage.chatFile, null, assistanceId, ChatMessageType.User);

      if (this.fileInput) {
        this.fileInput.nativeElement.value = '';
      }

      console.log("sending message:", translateChatOn, translationLanguage, this.newMessage.chatFile);

      var formData: FormData = this.apiService.getFormDataUploadFile(this.signalService.getConnectionId()!, this.userDataService.assetInfo.id!, this.newMessage, translateChatOn, translationLanguage, this.newMessage.chatFile?.file ?? null,
        this.attachment ?? null, assistanceId, this.userDataService.Name!, this.uploadFileSingleRequest);

      const fileToUpload = this.newMessage.chatFile?.file ?? this.attachment;
      if (this.uploadFileSingleRequest) {

        if (fileToUpload && fileToUpload.size > this.MAX_FORM_UPLOAD_SIZE) {
          this.translate.get("FILE.MAX_SIZE_ERROR").subscribe((text: string) => {
            this.snackBarService.openError(`${text}: ${this.MAX_FORM_UPLOAD_SIZE / 1024 / 1024} MB`);
          });
          return;
        }

        this.sendCompleteFile(formData);
      }
      else {
        if (fileToUpload && fileToUpload.size > this.MAX_CHUNK_UPLOAD_SIZE) {
           this.translate.get("FILE.MAX_SIZE_ERROR").subscribe((text: string) => {
             this.snackBarService.openError(`${text}:  ${this.MAX_CHUNK_UPLOAD_SIZE / 1024 / 1024 / 1024} GB.`);
          });
          return;
        }

        await this.sendFileChunksAsync(formData);
      }
        
      this.newMessage.message = "";
      this.newMessage.chatFile = null;
      this.resetTextareaHeight();
      this.clearEditor();

    } else console.log('No había participante, o mensaje o imagen');

  }

  private sendCompleteFile(formData: FormData) {
    this.apiService.sendChatMessageCompleteFile(formData).subscribe({
        next: event => {
          if (event.type === HttpEventType.UploadProgress) {
            if (event.total) this.loadingProgress = Math.round((100 * event.loaded) / event.total);
          } else if (event.type === HttpEventType.Response) {
            console.log("Archivo subido con éxito", event);
            this.lastChatMessageId = null;
            this.scrollDown("sendChatMessage. LastChatMessage a NULL linea 216");
          }
        },
        error: error => {
          const errorMessage = `Send chat message error ${this.userDataService.AssetId} - ${this.userDataService.ParticipantId} - ${this.userDataService.Name}`;
          this.logger.error(errorMessage, error);
          console.log("Send chat message error:", error);
          this.snackBarService.openError(error.error);
          this.loadingProgress = 0;
        },
        complete: () => {
          console.log("Subida completada");
          this.loadingProgress = 0;
        }
      });

  }

  private async sendFileChunksAsync(formData: FormData) {
    try {
      this.loadingProgress = 0;
      const { messageId, uploadId } = await this.apiService.sendChatMessageFileChunksAsync(formData);

      const fileToUpload = this.newMessage.chatFile?.file ?? this.attachment;
      if (fileToUpload) {
        console.log("chunks");
        await this.apiService.uploadFileInChunks(messageId, uploadId, fileToUpload, (progress) => {
          this.loadingProgress = progress;
          this.signalService.reportUploadProgress(this.userDataService.AssetId!, messageId, progress);
        });
      } else {
        console.log('No hay archivo o blob para subir, solo se envió mensaje de texto.');
      }

      this.loadingProgress = 0;
      console.log('Archivo subido y mensaje enviado con éxito');

      this.newMessage.message = "";
      this.newMessage.chatFile = null;
      this.resetTextareaHeight();

    } catch (error) {
      console.error('Error enviando mensaje o subiendo archivo', error);
      var errorMessage = this.getErrorMessage(error);
      this.snackBarService.openError(errorMessage);
      this.loadingProgress = 0;
    }
  }


  private getErrorMessage(error: unknown): string {
    if (error instanceof HttpErrorResponse) {
      if (error.status === 0) return 'Se ha perdido la conexión durante la subida.';
      if (typeof error.error === 'string') return error.error;
      if (error.error?.message) return error.error.message;

      return `Error ${error.status}: ${error.statusText}`;
    }

    if (error instanceof Error) return error.message;
    if (typeof error === 'string') return error;
    
    return 'Error inesperado al enviar el mensaje o subir el archivo.';
  }

  recordVoice(): void {
    if (this.isRecordingVoice) {
      this.isRecordingVoice = false;
      this.recordMediaService.stopRecordingAudio();
    } else {
      this.recordMediaService.startRecordingAudio();
      this.isRecordingVoice = true;
    }
  }

  openFileDialog() {
    this.fileInput.nativeElement.click(); 
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    var mediaType = this.fileHelperService.getFileType(file.name);
    this.newMessage.chatFile = new chatFile(-1, file.name, mediaType, "", file);
  }

  onDragEnter(event: DragEvent) {
    if (!this.isFileDrag(event)) return;
    event.preventDefault();
    this.dragCounter++;
    this.isDraggingFile = true;
  }

  onDragOver(event: DragEvent) {
    if (!this.isFileDrag(event)) return;
    event.preventDefault();
    event.dataTransfer!.dropEffect = 'copy';
  }

  onDragLeave(event: DragEvent) {
    if (!this.isFileDrag(event)) return;
    this.dragCounter--;
    if (this.dragCounter <= 0) {
      this.dragCounter = 0;
      this.isDraggingFile = false;
    }
  }

  onDrop(event: DragEvent) {
    if (!this.isFileDrag(event)) return;
    event.preventDefault();
    this.dragCounter = 0;
    this.isDraggingFile = false;

    const file = event.dataTransfer!.files[0];
    if (!file) return;

    var mediaType = this.fileHelperService.getFileType(file.name);
    if (mediaType === MediaType.Unknown) {
      this.translate.get("FILE.UNSUPPORTED_TYPE_ERROR").subscribe((text: string) => {
        this.snackBarService.openError(text);
      });
      return;
    }
    this.newMessage.chatFile = new chatFile(-1, file.name, mediaType, "", file);
  }

  private isFileDrag(event: DragEvent): boolean {
    return !!event.dataTransfer?.types.includes('Files');
  }

  clearAttachment() {
    this.newMessage.chatFile = null;
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }

  closeChat() {
    this.close.emit();
  }

  takePhoto() {
    console.log("take photo");
    let dialogRef: any;
    dialogRef = this.dialog.open(CameraComponent, {
      disableClose: true
    });

    dialogRef!.afterClosed().subscribe((result: File) => {
      if (result !== null) {
        console.log("result file", result);
        var mediaType = this.fileHelperService.getFileType(result.name);
        this.newMessage.chatFile = new chatFile(-1, result.name, mediaType, "", result);
      }
      dialogRef = null;
    });
  }

  deleteChatMessage(data: number) {
    this.chatService.deleteMessage(data);
    this.group = this.chatService.groupMessagesByDate();
  }

  trackByGroup(index: number, messageGroup: ChatMessage[]): number {
    return index;
  }

  trackByMessage(index: number, message: ChatMessage): number {
    return message.id!;
  }

  private setupVisibilityListener() {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.unreadMessages = 0;
        this.updateTitle();
      }
    });
  }

  private updateTitle() {
    const title = this.unreadMessages > 0 ? `(${this.unreadMessages}) ${this.originalTitle}` : this.originalTitle;
    this.titleService.setTitle(title);
  }

  private showNotification(userName: string, message: string) {
    var messageResult = message.length > this.MAX_LENGTH_NOTIFICATIONS ? message.slice(0, this.MAX_LENGTH_NOTIFICATIONS) + "..." : message;

    var title: string = "";
    var textToTranslate: string = "";

    if (this.userDataService.assetInfo.parentId == 0) {
      title = this.userDataService.assetInfo.name;
      textToTranslate = "NOTIFICATIONS.NEW_MESSAGE_ASSET";
    }
    else {
      title = this.userDataService.assetInfo.assistances[0].name;
      textToTranslate = "NOTIFICATIONS.NEW_MESSAGE_ASSISTANCE";
    }

    this.translate.get(textToTranslate).subscribe((text: string) => {
      new Notification(`${text} ${title}`, { body: `${userName}: ${messageResult}` });
    });

  }

  getChatSummary() {
    const screenWidth = window.innerWidth;
    const dialogWidth = screenWidth < 1100 ? '90vw' : '60%';

    const dialogRef = this.dialog.open(SummaryModalComponent, {
      width: dialogWidth,
      autoFocus: false,
      data:
      {
        assetId: this.userDataService.AssetId
      }
    });
  }

  loadPartialChat(getLastChatMessage: boolean) {
    this.loadingChat = true;

    var lastMessageId = this.chatService.getLastMessage();

    this.chatService.updateChat(lastMessageId, getLastChatMessage).subscribe({
      next: (result) => {
        console.log(result);
        if (result != null) { 
          this.group = this.chatService.groupMessagesByDate();
          this.lastChatMessageId = result.lastChatMessageId;

          var messagesGroup = this.group[this.group.length - 1]; //check last message id
          if (getLastChatMessage && this.lastChatMessageId !== messagesGroup[messagesGroup.length - 1]?.id) this.showDividerNewMessages = true;
          setTimeout(() => this.scrollDown("loadPartialChat"), 0);
          console.log("showDividerNewMessages", this.showDividerNewMessages, getLastChatMessage, this.lastChatMessageId);
        }

        this.loadingChat = false;
      },
      error: (err) => {
        console.error('Error al cargar los datos:', err);
        this.loadingChat = false;
      },
    });
  }

  scrollDown(sender: string): void {
    console.log("scroll down", sender, this.lastChatMessageId);
    setTimeout(() => {
      if (this.messagesContainer && this.messagesContainer.nativeElement) {

        var scrollValue = this.messagesContainer.nativeElement.scrollHeight;

        if (this.lastChatMessageId != null) {
          var target = this.messagesContainer.nativeElement.querySelector(`[id="newMessages"]`); //new messages
          if (!target) {
            var messagesGroup = this.group[this.group.length - 1]; //check last message id
            if (this.lastChatMessageId !== messagesGroup[messagesGroup.length - 1]?.id) target = this.messagesContainer.nativeElement.querySelector(`[data-id="${this.lastChatMessageId}"]`); //load more messages
          }

          if (target) {
            scrollValue = (target as HTMLElement).offsetTop; 
          }
        }

        this.messagesContainer.nativeElement.scrollTop = scrollValue;
      }
    }, 0);
  }

  scrollDownFile(sender: string): void {
    this.scrollDown(sender);
  }

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const container = this.messagesContainer.nativeElement;
    const threshold = 30; // margen
    const position = container.scrollTop + container.clientHeight;

    this.userScrollAtBottom = container.scrollHeight - position <= threshold;

    if (this.userScrollAtBottom) {
      setTimeout(() => { this.showDividerNewMessages = false; this.lastChatMessageId = null; }, 10000);
      this.unreadMessages = 0;
      this.updateTitle();
    }

    if (element.scrollTop === 0) {
      this.loadPartialChat(false);
    }

    if (element.scrollTop > this.lastScrollTop) {
      this.checkUnreadDivider();
    }

    this.lastScrollTop = element.scrollTop;
  }

  private checkUnreadDivider() {
    if (!this.showDividerNewMessages) return;

    const container = this.messagesContainer.nativeElement;
    const unreadElement = container.querySelector(`[data-id="${this.lastChatMessageId}"]`);

    const rect = unreadElement.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    if (rect.bottom < containerRect.top) {
      console.log("remove divider bottom<top", rect.bottom, containerRect.top);
      this.showDividerNewMessages = false;
    }

  }

  toggleEmojiPicker(event: Event) {
    event.stopPropagation();
    this.showEmojiPicker = !this.showEmojiPicker;
  }

  addEmoji(event: any) {
    this.showEmojiPicker = false;

    const emoji = event.emoji.native;
    const editor = this.textarea.nativeElement;
    editor.focus();

    const span = document.createElement('span');
    span.classList.add('emoji');
    span.dataset["unicode"] = emoji;

    // mostrar Twemoji
    span.innerHTML = twemoji.parse(emoji, {
      folder: 'svg',
      ext: '.svg'
    });

    const sel = window.getSelection();
    const range = sel!.getRangeAt(0);

    range.deleteContents();
    range.insertNode(span);

    // mover cursor detrás del emoji
    range.setStartAfter(span);
    range.collapse(true);

    sel!.removeAllRanges();
    sel!.addRange(range);

    this.updateMessage();
  }

  updateMessage() {
    let message = '';
    let node;

    const editor = this.textarea.nativeElement;
    const walker = document.createTreeWalker(editor, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);

    while (node = walker.nextNode()) {

      if (node.nodeType === Node.TEXT_NODE) {
        if (!(node.parentElement as HTMLElement)?.dataset?.["unicode"]) {
          message += node.textContent;
        }
      }

      if (node.nodeType === Node.ELEMENT_NODE && (node as HTMLElement).dataset && (node as HTMLElement).dataset["unicode"]) {
        message += (node as HTMLElement).dataset["unicode"];
      }
    }

    this.newMessage.message = message;
  }

  onInput() {
    this.updateMessage();
  }

  clearEditor() {
    this.textarea.nativeElement.innerHTML = '';
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;

    if (this.showEmojiPicker && this.emojiPicker && !this.emojiPicker.nativeElement.contains(target)) {
      this.showEmojiPicker = false;
    }
  }
}
